// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_s1w","cls2":"common-cls2_N0I common-cls1_s1w","small":"common-small_MTX","altLook":"common-altLook_jXG"};